import { TextFeedResponse } from "./feedsService";

export interface StarIconsResult {
  filledStars: string;
  emptyStars: string;
  halfStar?: string;
}

export const ratingService = {

  getRatingIcon(reviewType: number, rating: number, totalStars: number = 5) {
    if (reviewType == 2) {
      const { filledStars, emptyStars } = this.getTrustpilotStarIcon(rating, totalStars)

      return filledStars + emptyStars
    }
    else if (reviewType == 3) {
      const { filledStars, emptyStars } = this.getTripadvisorIcon(rating, totalStars)

      return filledStars + emptyStars
    }
    else if (reviewType == 4) {
      return this.getIMDbStarIcon(rating, totalStars)
    }
    else if (reviewType == 5) {
      return this.getBookingComStarIcon(rating)
    }
    else if (reviewType == 6) {
      const { filledStars, emptyStars } = this.getAppSumoStarIcon(rating)

      return filledStars + emptyStars
    } else if(reviewType == 7){
      const { filledStars, emptyStars } = this.getGumroadStarIcon(rating)

      return filledStars + emptyStars
    } else {
      const { filledStars, halfStar, emptyStars } = this.getCommonStarIcon(rating, totalStars)

      return filledStars + halfStar + emptyStars;
    }
  },

  getCommonStarIcon(rating: number, totalStars: number = 5): StarIconsResult {
    // Ensure rating is a valid number
    const normalizedRating = Number(rating) || 0;

    // Calculate the number of full, half, and empty stars
    const fullStars = Math.floor(normalizedRating);
    const hasHalfStar = normalizedRating % 1 !== 0;
    const emptyStars = totalStars - fullStars - (hasHalfStar ? 1 : 0);

    // SVG definitions
    const filledStarSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M23.25 9.52969H14.6419L12 1.5L9.35812 9.52969H0.75L7.79109 14.4703L5.04891 22.5L12 17.5238L18.9511 22.5L16.2037 14.4703L23.25 9.52969Z" fill="#FFA81B"/>
        </svg>
    `;

    const halfStarSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <mask id="mask0_3926_6" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="1" width="12" height="23">
            <rect y="1.5" width="12" height="21.75" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_3926_6)">
            <path d="M23.25 9.52969H14.6419L12 1.5L9.35812 9.52969H0.75L7.79109 14.4703L5.04891 22.5L12 17.5238L18.9511 22.5L16.2037 14.4703L23.25 9.52969Z" fill="#FFA81B"/>
          </g>
          <mask id="mask1_3926_6" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="12" y="1" width="12" height="23">
            <rect width="12" height="21.75" transform="matrix(-1 0 0 1 24 1.5)" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask1_3926_6)">
            <path d="M9.83308 9.68595L9.71999 10.0297H9.35813H2.33401L8.0833 14.0609L8.39097 14.2766L8.26933 14.6322L6.02744 21.1846L11.7089 17.1172L12 16.9088L12.2911 17.1172L17.9738 21.1855L15.7357 14.6319L15.6144 14.2766L15.9217 14.061L21.6669 10.0297H14.6419H14.28L14.1669 9.68595L12 3.09984L9.83308 9.68595Z" stroke="#FFA81B"/>
          </g>
        </svg>
    `;

    const emptyStarSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M13.962 9.90454L14.0743 10.25H14.4375H20.8867L15.6547 13.8376L15.3428 14.0515L15.4638 14.4099L17.4943 20.4264L12.2934 16.6576L12 16.445L11.7066 16.6576L6.50566 20.4264L8.53625 14.4099L8.65719 14.0515L8.34526 13.8376L3.1133 10.25H9.5625H9.92574L10.038 9.90454L12 3.86767L13.962 9.90454Z" stroke="#FFA81B"/>
        </svg>
    `;

    return {
      filledStars: Array(fullStars).fill(filledStarSVG).join(''),
      halfStar: hasHalfStar ? halfStarSVG : '',
      emptyStars: Array(emptyStars).fill(emptyStarSVG).join('')
    };
  },

  getIMDbStarIcon(rating: number, maxStars: number = 10) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M23.25 9.52969H14.6419L12 1.5L9.35812 9.52969H0.75L7.79109 14.4703L5.04891 22.5L12 17.5238L18.9511 22.5L16.2037 14.4703L23.25 9.52969Z" fill="#FFA81B"/>
      </svg> <span class="dark:text-white">
                          <strong>${rating}</strong>
                          / ${maxStars}
                        </span>`;
  },


  getGumroadStarIcon(rating: number, totalStars: number = 5): StarIconsResult {
    // Ensure rating is a valid number
    const normalizedRating = Number(rating) || 0;

    // Calculate the number of full, half, and empty stars
    const fullStars = Math.floor(normalizedRating);
    const emptyStars = totalStars - fullStars;

    // SVG definitions
    const filledStarSVG = `
        <svg class="text-gray-900 dark:text-white" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 1024 1024">
            <path fill="currentColor" d="m908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5c-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1l-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2c17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9l183.7-179.1c5-4.9 8.3-11.3 9.3-18.3c2.7-17.5-9.5-33.7-27-36.3">
            </path>
        </svg>
    `;

    const emptyStarSVG = `
        <svg class="text-gray-900 dark:text-white" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 1024 1024">
                <path fill="currentColor" d="m908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5c-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1l-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2c17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9l183.7-179.1c5-4.9 8.3-11.3 9.3-18.3c2.7-17.5-9.5-33.7-27-36.3M664.8 561.6l36.1 210.3L512 672.7L323.1 772l36.1-210.3l-152.8-149L417.6 382L512 190.7L606.4 382l211.2 30.7z">
                </path>
        </svg>
    `;

    return {
      filledStars: Array(fullStars).fill(filledStarSVG).join(''),
      emptyStars: Array(emptyStars).fill(emptyStarSVG).join('')
    };
  },

  getAppSumoStarIcon(rating: number, totalStars: number = 5): StarIconsResult {
    // Ensure rating is a valid number
    const normalizedRating = Number(rating) || 0;

    // Calculate the number of full, half, and empty stars
    const fullStars = Math.floor(normalizedRating);
    const emptyStars = totalStars - fullStars;

    // SVG definitions
    const filledStarSVG = `
        <svg class="text- width="30" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3590_4311)">
            <path d="M20.8791 16.8732L2.1501 18.9322C1.85929 18.9321 1.5747 18.848 1.33053 18.6901C1.08635 18.5321 0.892975 18.307 0.773635 18.0419C0.654295 17.7767 0.614068 17.4827 0.657789 17.1952C0.70151 16.9077 0.827318 16.6389 1.0201 16.4212C4.4581 12.5042 11.6391 3.99219 18.2931 3.99219C19.6714 3.99194 21.0213 4.38387 22.1851 5.12219C26.3031 7.70819 25.0221 12.3532 23.8421 14.9392C23.5828 15.5096 23.1664 15.9944 22.6417 16.3369C22.117 16.6794 21.5056 16.8654 20.8791 16.8732Z" fill="#FFBC00"></path>
            <path d="M18.2659 1.984C11.1849 1.984 4.17986 9.742 0.237864 14.237C0.059668 13.9613 -0.0221662 13.6344 0.00515374 13.3073C0.0324737 12.9801 0.167408 12.6713 0.388864 12.429C3.82786 8.512 11.0089 1.1789e-07 17.6629 1.1789e-07C19.0411 -0.000248164 20.391 0.391678 21.5549 1.13C22.6314 1.7823 23.4748 2.75758 23.9649 3.917C23.7418 3.73636 23.5081 3.56939 23.2649 3.417C21.7665 2.47811 20.0331 1.98202 18.2649 1.986" fill="#FFBC00"></path>
            </g>
            <defs>
            <clipPath id="clip0_3590_4311">
                <rect width="25" height="18.932" fill="white"></rect>
            </clipPath>
            </defs>
        </svg>
    `;

    const emptyStarSVG = `
        <svg width="30" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_3590_4336)">
              <path d="M20.8791 16.8732L2.1501 18.9322C1.85929 18.9321 1.5747 18.848 1.33053 18.6901C1.08635 18.5321 0.892975 18.307 0.773635 18.0419C0.654295 17.7767 0.614068 17.4827 0.657789 17.1952C0.70151 16.9077 0.827318 16.6389 1.0201 16.4212C4.4581 12.5042 11.6391 3.99219 18.2931 3.99219C19.6714 3.99194 21.0213 4.38387 22.1851 5.12219C26.3031 7.70819 25.0221 12.3532 23.8421 14.9392C23.5828 15.5096 23.1664 15.9944 22.6417 16.3369C22.117 16.6794 21.5056 16.8654 20.8791 16.8732Z" fill="#C6CED7"></path>
              <path d="M18.2659 1.984C11.1849 1.984 4.17986 9.742 0.237864 14.237C0.059668 13.9613 -0.0221662 13.6344 0.00515374 13.3073C0.0324737 12.9801 0.167408 12.6713 0.388864 12.429C3.82786 8.512 11.0089 1.1789e-07 17.6629 1.1789e-07C19.0411 -0.000248164 20.391 0.391678 21.5549 1.13C22.6314 1.7823 23.4748 2.75758 23.9649 3.917C23.7418 3.73636 23.5081 3.56939 23.2649 3.417C21.7665 2.47811 20.0331 1.98202 18.2649 1.986" fill="#C6CED7"></path>
              </g>
              <defs>
              <clipPath id="clip0_3590_4336">
                  <rect width="25" height="18.932" fill="white"></rect>
              </clipPath>
              </defs>
          </svg>
    `;

    return {
      filledStars: Array(fullStars).fill(filledStarSVG).join(''),
      emptyStars: Array(emptyStars).fill(emptyStarSVG).join('')
    };
  },

  getTrustpilotStarIcon(rating: number, totalStars: number = 5): StarIconsResult {
    // Ensure rating is a valid number
    const normalizedRating = Number(rating) || 0;
    // Calculate the number of full, half, and empty stars
    const fullStars = normalizedRating;
    const emptyStars = totalStars - fullStars;

    const trustpilotStars: any = {
      0: `<svg width="20" height="20" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_488_7980)">
              <path d="M96 0H0V96H96V0Z" fill="#DCDCE6"></path>
              <path d="M48 64.6999L62.6 61L68.7 79.8L48 64.6999ZM81.6 40.4H55.9L48 16.2L40.1 40.4H14.4L35.2 55.4L27.3 79.5999L48.1 64.5999L60.9 55.4L81.6 40.4Z" fill="white"></path>
            </g>
            <defs>
              <clipPath id="clip0_488_7980">
                <rect width="96" height="96" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>`,
      1: `<svg width="20" height="20" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_488_7967)">
              <path d="M96 0H0V96H96V0Z" fill="#FF3722"></path>
              <path d="M48 64.6999L62.6 61L68.7 79.8L48 64.6999ZM81.6 40.4H55.9L48 16.2L40.1 40.4H14.4L35.2 55.4L27.3 79.5999L48.1 64.5999L60.9 55.4L81.6 40.4Z" fill="white"></path>
            </g>
            <defs>
              <clipPath id="clip0_488_7967">
                <rect width="96" height="96" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>`,
      2: `<svg width="20" height="20" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_488_7954)">
              <path d="M96 0H0V96H96V0Z" fill="#FF8622"></path>
              <path d="M48 64.6999L62.6 61L68.7 79.8L48 64.6999ZM81.6 40.4H55.9L48 16.2L40.1 40.4H14.4L35.2 55.4L27.3 79.5999L48.1 64.5999L60.9 55.4L81.6 40.4Z" fill="white"></path>
            </g>
            <defs>
              <clipPath id="clip0_488_7954">
                <rect width="96" height="96" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>`,
      3: `<svg width="20" height="20" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_488_7941)">
              <path d="M96 0H0V96H96V0Z" fill="#FFCE00"></path>
              <path d="M48 64.6999L62.6 61L68.7 79.8L48 64.6999ZM81.6 40.4H55.9L48 16.2L40.1 40.4H14.4L35.2 55.4L27.3 79.5999L48.1 64.5999L60.9 55.4L81.6 40.4Z" fill="white"></path>
            </g>
            <defs>
              <clipPath id="clip0_488_7941">
                <rect width="96" height="96" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>`,
      4: `<svg width="20" height="20" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_488_7928)">
              <path d="M96 0H0V96H96V0Z" fill="#73CF11"></path>
              <path d="M48 64.6999L62.6 61L68.7 79.8L48 64.6999ZM81.6 40.4H55.9L48 16.2L40.1 40.4H14.4L35.2 55.4L27.3 79.5999L48.1 64.5999L60.9 55.4L81.6 40.4Z" fill="white"></path>
            </g>
            <defs>
              <clipPath id="clip0_488_7928">
                <rect width="96" height="96" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>`,
      5: `<svg width="20" height="20" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_488_7915)">
              <path d="M96 0H0V96H96V0Z" fill="#00B67A"></path>
              <path d="M48 64.6999L62.6 61L68.7 79.8L48 64.6999ZM81.6 40.4H55.9L48 16.2L40.1 40.4H14.4L35.2 55.4L27.3 79.5999L48.1 64.5999L60.9 55.4L81.6 40.4Z" fill="white"></path>
            </g>
            <defs>
              <clipPath id="clip0_488_7915">
                <rect width="96" height="96" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>`
    }

    // SVG definitions
    const filledStarSVG = trustpilotStars[fullStars];

    const emptyStarSVG = trustpilotStars[0];

    return {
      filledStars: Array(fullStars).fill(filledStarSVG).join(''),
      emptyStars: Array(emptyStars).fill(emptyStarSVG).join('')
    };
  },

  getTripadvisorIcon(rating: number, totalStars: number = 5): StarIconsResult {
    // Ensure rating is a valid number
    const normalizedRating = Number(rating) || 0;

    // Calculate the number of full, half, and empty stars
    const fullStars = Math.floor(normalizedRating);
    const emptyStars = totalStars - fullStars;

    // SVG definitions
    const filledStarSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path style="fill: #05aa6c" fill="currentColor" d="M12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22">
          </path>
        </svg>
    `;

    const emptyStarSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path style="fill: #05aa6c" fill="currentColor" d="M12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8">
            </path>
        </svg>
    `;

    return {
      filledStars: Array(fullStars).fill(filledStarSVG).join(''),
      emptyStars: Array(emptyStars).fill(emptyStarSVG).join('')
    };
  },

  getBookingComStarIcon(rating: number) {
    return `<div class="w-8 h-8 text-sm rounded-tl-md rounded-tr-md rounded-br-md flex items-center justify-center text-white bg-[#003b95]">
            ${rating}
        </div>`;
  },

  getThumbIcon(response:string){
      if(response == TextFeedResponse.One){
        return `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path
                  d="M2.3335 14.5855C2.3335 13.9666 2.57933 13.3731 3.01691 12.9356C3.4545 12.498 4.04799 12.2521 4.66683 12.2521C5.59509 12.2521 6.48533 12.6209 7.1417 13.2773C7.79808 13.9336 8.16683 14.8239 8.16683 15.7521V20.4188C8.16683 21.3471 7.79808 22.2373 7.1417 22.8937C6.48533 23.5501 5.59509 23.9188 4.66683 23.9188C4.04799 23.9188 3.4545 23.673 3.01691 23.2354C2.57933 22.7978 2.3335 22.2043 2.3335 21.5855V14.5855ZM18.059 9.10914L17.7475 10.1125C17.4932 10.935 17.366 11.3456 17.464 11.6711C17.5465 11.9352 17.7202 12.1614 17.954 12.3093C18.2468 12.4936 18.689 12.4936 19.5757 12.4936H20.047C23.0453 12.4936 24.5445 12.4936 25.2527 13.3803C25.3336 13.4822 25.4055 13.5899 25.4685 13.7035C26.0133 14.6928 25.3938 16.0263 24.1548 18.6933C23.0185 21.141 22.4492 22.3648 21.3945 23.0846C21.2918 23.1546 21.1868 23.2208 21.0795 23.283C19.9688 23.9188 18.5922 23.9188 15.8388 23.9188H15.2427C11.906 23.9188 10.2388 23.9188 9.20283 22.9155C8.16683 21.911 8.16683 20.2951 8.16683 17.0635V15.9271C8.16683 14.2296 8.16683 13.3803 8.46783 12.6021C8.77 11.8251 9.34633 11.187 10.5013 9.90831L15.2742 4.62331C15.3943 4.49031 15.4538 4.42498 15.5075 4.37831C15.7461 4.17258 16.0559 4.06849 16.3703 4.08833C16.6848 4.10818 16.9789 4.25038 17.1898 4.48448C17.2365 4.53698 17.2867 4.61048 17.3882 4.75748C17.5457 4.98614 17.6238 5.10048 17.6927 5.21481C18.3087 6.23098 18.4942 7.43848 18.213 8.58648C18.1815 8.71364 18.1407 8.84548 18.059 9.10914Z"
                  fill="#BBF7D0" />
                <path
                  d="M2.3335 14.5855C2.3335 13.9666 2.57933 13.3731 3.01691 12.9356C3.4545 12.498 4.04799 12.2521 4.66683 12.2521C5.59509 12.2521 6.48533 12.6209 7.1417 13.2773C7.79808 13.9336 8.16683 14.8239 8.16683 15.7521V20.4188C8.16683 21.3471 7.79808 22.2373 7.1417 22.8937C6.48533 23.5501 5.59509 23.9188 4.66683 23.9188C4.04799 23.9188 3.4545 23.673 3.01691 23.2354C2.57933 22.7978 2.3335 22.2043 2.3335 21.5855V14.5855ZM18.059 9.10914L17.7475 10.1125C17.4932 10.935 17.366 11.3456 17.464 11.6711C17.5465 11.9352 17.7202 12.1614 17.954 12.3093C18.2468 12.4936 18.689 12.4936 19.5757 12.4936H20.047C23.0453 12.4936 24.5445 12.4936 25.2527 13.3803C25.3336 13.4822 25.4055 13.5899 25.4685 13.7035C26.0133 14.6928 25.3938 16.0263 24.1548 18.6933C23.0185 21.141 22.4492 22.3648 21.3945 23.0846C21.2918 23.1546 21.1868 23.2208 21.0795 23.283C19.9688 23.9188 18.5922 23.9188 15.8388 23.9188H15.2427C11.906 23.9188 10.2388 23.9188 9.20283 22.9155C8.16683 21.911 8.16683 20.2951 8.16683 17.0635V15.9271C8.16683 14.2296 8.16683 13.3803 8.46783 12.6021C8.77 11.8251 9.34633 11.187 10.5013 9.90831L15.2742 4.62331C15.3943 4.49031 15.4538 4.42498 15.5075 4.37831C15.7461 4.17258 16.0559 4.06849 16.3703 4.08833C16.6848 4.10818 16.9789 4.25038 17.1898 4.48448C17.2365 4.53698 17.2867 4.61048 17.3882 4.75748C17.5457 4.98614 17.6238 5.10048 17.6927 5.21481C18.3087 6.23098 18.4942 7.43848 18.213 8.58648C18.1815 8.71364 18.1407 8.84548 18.059 9.10914Z"
                  stroke="#22C55E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>`;
      }
  
      if(response == TextFeedResponse.Zero){
        return `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path d="M25.6665 13.4145C25.6665 14.0334 25.4207 14.6269 24.9831 15.0644C24.5455 15.502 23.952 15.7479 23.3332 15.7479C22.4049 15.7479 21.5147 15.3791 20.8583 14.7227C20.2019 14.0664 19.8332 13.1761 19.8332 12.2479L19.8332 7.58119C19.8332 6.65293 20.2019 5.76269 20.8583 5.10632C21.5147 4.44994 22.4049 4.08119 23.3332 4.08119C23.952 4.08119 24.5455 4.32702 24.9831 4.76461C25.4207 5.20219 25.6665 5.79568 25.6665 6.41452L25.6665 13.4145ZM9.94101 18.8909L10.2525 17.8875C10.5068 17.065 10.634 16.6544 10.536 16.3289C10.4535 16.0648 10.2798 15.8386 10.046 15.6907C9.75317 15.5064 9.31101 15.5064 8.42434 15.5064L7.953 15.5064C4.95467 15.5064 3.45551 15.5064 2.74734 14.6197C2.66645 14.5178 2.59451 14.4101 2.53151 14.2965C1.98667 13.3072 2.60617 11.9737 3.84517 9.30669C4.9815 6.85902 5.55084 5.63519 6.60551 4.91536C6.70817 4.84536 6.81317 4.77925 6.9205 4.71703C8.03117 4.08119 9.40784 4.08119 12.1612 4.08119L12.7573 4.08119C16.094 4.08119 17.7612 4.08119 18.7972 5.08452C19.8332 6.08902 19.8332 7.70486 19.8332 10.9365L19.8332 12.0729C19.8332 13.7704 19.8332 14.6197 19.5322 15.3979C19.23 16.1749 18.6537 16.813 17.4987 18.0917L12.7258 23.3767C12.6057 23.5097 12.5462 23.575 12.4925 23.6217C12.2539 23.8274 11.9441 23.9315 11.6297 23.9117C11.3152 23.8918 11.0211 23.7496 10.8102 23.5155C10.7635 23.463 10.7133 23.3895 10.6118 23.2425C10.4543 23.0139 10.3762 22.8995 10.3073 22.7852C9.69134 21.769 9.50584 20.5615 9.78701 19.4135C9.81851 19.2864 9.85934 19.1545 9.94101 18.8909Z" fill="#FEE2E2"></path>
                <path d="M25.6665 13.4145C25.6665 14.0334 25.4207 14.6269 24.9831 15.0644C24.5455 15.502 23.952 15.7479 23.3332 15.7479C22.4049 15.7479 21.5147 15.3791 20.8583 14.7227C20.2019 14.0664 19.8332 13.1761 19.8332 12.2479L19.8332 7.58119C19.8332 6.65293 20.2019 5.76269 20.8583 5.10632C21.5147 4.44994 22.4049 4.08119 23.3332 4.08119C23.952 4.08119 24.5455 4.32702 24.9831 4.76461C25.4207 5.20219 25.6665 5.79568 25.6665 6.41452L25.6665 13.4145ZM9.94101 18.8909L10.2525 17.8875C10.5068 17.065 10.634 16.6544 10.536 16.3289C10.4535 16.0648 10.2798 15.8386 10.046 15.6907C9.75317 15.5064 9.31101 15.5064 8.42434 15.5064L7.953 15.5064C4.95467 15.5064 3.45551 15.5064 2.74734 14.6197C2.66645 14.5178 2.59451 14.4101 2.53151 14.2965C1.98667 13.3072 2.60617 11.9737 3.84517 9.30669C4.9815 6.85902 5.55084 5.63519 6.60551 4.91536C6.70817 4.84536 6.81317 4.77925 6.9205 4.71703C8.03117 4.08119 9.40784 4.08119 12.1612 4.08119L12.7573 4.08119C16.094 4.08119 17.7612 4.08119 18.7972 5.08453C19.8332 6.08902 19.8332 7.70486 19.8332 10.9365L19.8332 12.0729C19.8332 13.7704 19.8332 14.6197 19.5322 15.3979C19.23 16.1749 18.6537 16.813 17.4987 18.0917L12.7258 23.3767C12.6057 23.5097 12.5462 23.575 12.4925 23.6217C12.2539 23.8274 11.9441 23.9315 11.6297 23.9117C11.3152 23.8918 11.0211 23.7496 10.8102 23.5155C10.7635 23.463 10.7133 23.3895 10.6118 23.2425C10.4543 23.0139 10.3762 22.8995 10.3073 22.7852C9.69134 21.769 9.50584 20.5615 9.78701 19.4135C9.81851 19.2864 9.85934 19.1545 9.94101 18.8909Z" stroke="#F87171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>`;
      }
    },
}